import gql from 'graphql-tag';
import className from 'classnames/bind';
import { MilestonesFragment } from '@graphqlTypes';
import { Container, SectionFooter, SectionHeader, RevealWrapper } from '@components';

import styles from './Milestones.module.scss';
import { useRef } from 'react';
import { useInView } from 'motion/react';
import { useViewSize } from '@/providers/ViewSizeContext';
import { AnimVals } from '@/utils/animUtils';
const cx = className.bind(styles);

export default function Milestones({ items, includeFooter, footer, subhead, headline }: MilestonesFragment) {
  const showHeader = Boolean(headline || subhead);

  // -------------------- Animation

  const rootEl = useRef<HTMLElement | null>(null);
  const { isDesktop } = useViewSize();
  const REVEAL = AnimVals;
  const triggerPercent = isDesktop ? REVEAL.lg.triggerPercent : REVEAL.sm.triggerPercent;
  const isInView = useInView(rootEl, { amount: triggerPercent, once: REVEAL.once });
  const isRevealEnabled = true;

  // -------------------- Render

  return (
    <section className={cx(["milestones"])} ref={rootEl}>
      <RevealWrapper isInView={isInView}>
        <Container>
          { showHeader &&
            <SectionHeader
              headline={headline}
              subhead={subhead}
              isRevealEnabled={isRevealEnabled}
              isInView={isInView}
            />
          }
          <div className={cx("row")}>
            {items.map((item, index) => (
              <div key={index} className={cx("milestone")}>
                <h2 className={cx(["title-lc-l", "headline"])}>{item.headline}</h2>
                <p className={cx(["text-l", "subtitle"])}>{item.subtitle}</p>
              </div>
            ))}
          </div>
          {includeFooter && <SectionFooter text={footer.text} ctas={footer.ctas} />}
        </Container>
      </RevealWrapper>
    </section>
  )
}

Milestones.fragments = {
  entry: gql`
    fragment Milestones on FlexiblePageContentContentMilestonesLayout {
      headline
      subhead
      items {
        headline
        subtitle
      }
      includeFooter
      footer {
        text
        ctas {
          linkType
          label
          externalLink
          page {
            node {
              uri
            }
          }
        }
      }
    }
  `,
};
